<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">ELI Assessments</h1>
                    <div class="btns-container">
                        <div class="margin-right-5">
                            <a (click)="getAssessmentTypes()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fas fa-dollar-sign text-white-50"> <span class="button-text">Pricing</span></i>
                            </a>
                        </div>
                        <div>
                            <a [routerLink]="['/app/neweli']" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-plus text-white-50"> <span class="button-text">Create Assessment</span></i>
                            </a>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading assessments, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">
                    <div class="card shadow">

                        <!--<div class="container-fluid">-->
                        <!--<p class="componentTitle">ELI Assessments</p>-->
                        <!--<div class="row">
                <br />-->
                        <!--<div class="col-sm-9 table-actions">-->
                        <!-- <div (click)="editSelected()" [ngClass]="{'icon_disabled': canEdit == false}">
                <i class="material-icons" [ngClass]="{'icon_disabled': canEdit == false}">edit</i>
                <span>Edit</span>
            </div>

            <div (click)="deleteSelected()" [ngClass]="{'icon_disabled': canDelete == false}">
                <i class="material-icons" [ngClass]="{'icon_disabled': canDelete == false}">delete</i>
                <span>Delete</span>
            </div> -->
                        <!--</div>-->
                        <!--<div class="col-sm-12 text-right table-actions-buttons">
                        <button [routerLink]="['/app/neweli']" type="button" class="btn">Create</button>
                    </div>
                </div>
            </div>-->

                        <div class="container-fluid">

                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="true"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="gridOptions"
                                                 [rowData]="assessments"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="true"
                                                 [enableColResize]="true"
                                                 (rowClicked)="onRowClicked($event)"
                                                 (gridReady)="onGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="rowSelection"
                                                 (rowSelected)="onRowSelected($event)"
                                                 (selectionChanged)="onSelectionChanged($event)"
                                                 [rowMultiSelectWithClick]="true"
                                                 [suppressRowClickSelection]="true">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!--/*Pricing MODAL*/-->
<div id="pricingModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document" style="max-width:450px;">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">ELI Pricing</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">Assessment: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <select style="width:100%;" id="assessmentId" (change)="getAssessmentPricing(_type.value)" #_type>
                            <option *ngFor="let _type of assessmentsTypes" [value]="_type.Id">{{_type.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-12 noPadding">
                        <table class="table table-bordered table-striped"> 
                            <thead>
                                <tr>
                                    <th style="width:33.33%"><b>From</b></th>
                                    <th style="width:33.33%"><b>To</b></th>
                                    <th style="width:33.33%"><b>Price</b></th>
                                </tr>
                            </thead>
                            <tbody id="pricingBody">
                                <ng-container *ngIf="prices.length > 0; else tableElse;">
                                    <tr *ngFor="let entry of prices; let i = index" class="priceEntries">
                                        <td class="rangeStart">{{entry.RangeStart}}</td>
                                        <td class="rangeEnd">{{(entry.RangeEnd=='0')?'+':entry.RangeEnd}}</td>
                                        <td style="position:relative;">
                                            <b style="position: absolute; left: 17px; top: 13px;">$ </b>
                                            <input style="width: 100%; max-width: 150px; padding: 1px 0 0 20px; height:20px;" 
                                                   inputmode="numeric" 
                                                   type="number" 
                                                   step="1"
                                                   min="1" 
                                                   class="price" 
                                                   id="price{{i}}" 
                                                   value="{{entry.Price}}"
                                                   (keyup)="preventFirst0($event)" /></td>
                                    </tr>
                                </ng-container>
                                
                                <ng-template #tableElse>
                                    <tr class="text-center">
                                        <td style="width:100%;" colspan="3">No Rows to show</td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" class="btn btn-secondary" type="button">Close</button>
                        <button (click)="saveAssessmentPricing(_type.value)" class="btn btn-primary" style="margin-right: 20px;" type="button">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>